import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.577 3.139a9.003 9.003 0 0 0-6.668 16.287 1 1 0 1 1-1.132 1.65 11.003 11.003 0 0 1 8.15-19.907 1 1 0 0 1-.35 1.97m3.047-.06a1 1 0 0 1 1.384-.289 11.002 11.002 0 0 1-8.145 20.004 1 1 0 1 1 .386-1.963 9.002 9.002 0 0 0 6.664-16.367 1 1 0 0 1-.29-1.385m-3.54 9.393a2.502 2.502 0 0 0-1.08-4.758 2.5 2.5 0 0 0-1.079 4.758l-1.03 2.81a1.072 1.072 0 0 0 1.03 1.366h2.16c.711 0 1.225-.682 1.03-1.367z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
//# sourceMappingURL=ic_brand_1password-CAy3Eo50.js.map
